import { GridItem, GridSpacer } from '@bnnvara/grids';
import React from 'react';

import { MembershipContainer } from '../components/Membership';

const ComposableMembershipForm = (props) => {
  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="12"
      columnStartLg="3"
      columnEndLg="11"
    >
      <GridSpacer />
      <MembershipContainer {...props} />
    </GridItem>
  );
};

export default ComposableMembershipForm;
